import './google_my_business_content.js.coffee'
Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent extends
Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent
  @SUB_TYPE = 'google-my-business-review'

  constructor: (author, review, locationSummary) ->
    @review = review
    super(author, locationSummary)

  getMainText: =>
    @review.getText()

  getContentId: =>
    @review.getContentId()

  getCreatedAt: =>
    @review.getCreatedAt()

  getStarRating: =>
    @review.getStarRating()

  getReviewId: =>
    @review.getReviewId()

  getParentId: ->
    null

  isBrandContent: ->
    false

  getSubType: ->
    Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent.SUB_TYPE

  getPrivacy: ->
    'public'

  hasRelated: ->
    true
